export default {
    pageTitle: 'Paramètres',
    leftPanel: {
        teamDetails: 'Organisation',
        users: 'Utilisateurs',
        templates: 'Messages prédéfinis',
        profile: 'Profil',
        notifications: 'Alertes',
        messages: 'Messages automatisés',
        usage: {
            title: 'Utilisation',
            segmentsSent: '{usage} / {limit} SMS utilisés ce mois',
        },
    },
    rightPanel: {
        profile: {
            firstName: 'Prénom',
            lastName: 'Nom',
            locale: 'Langue',
            timezone: 'Fuseau horaire',
            email: 'Courriel',
            password: 'Mot de passe',
            confirm: 'Confirmation du mot de passe',
            subtitles: {
                profile: 'Profil',
                general: 'Général',
                localization: 'Internationalisation',
                changePassword: 'Changer le mot de passe',
                createPassword: 'Créer le mot de passe',
            },
            messages: {
                updateSuccessful: 'Profil enregistré avec succès.',
            },
            errors: {
                update: 'Une erreur est survenue lors de la sauvegarde.',
            },
        },
        notifications: {
            type: 'Type d\'alerte',
            screen: 'Écran',
            email: 'Courriel',
            newMessageConfirmation: 'Nouveau message',
            subtitles: {
                notifications: 'Alertes',
            },
            messages: {
                updateSuccessful: 'Préférences d\'alertes enregistrées avec succès.',
            },
            errors: {
                update: 'Une erreur est survenue lors de la sauvegarde.',
            },
        },
        messages: {
            unsubscribeMessage: 'Message de désabonnement',
            unsubscribeMessageTooltip: 'Ce message est envoyé automatiquement après la première communication de masse envoyée à un client, comme une confirmation de rendez-vous ou une campagne. Il est nécessaire pour se conformer à la Loi canadienne anti-pourriel.',
            confirmationMessage: 'Message de confirmation',
            confirmationMessageTooltip: 'Ce message est ajouté automatiquement à la fin des messages de confirmation de rendez-vous. Il devrait indiquer au client ce qu\'il peut répondre pour confirmer ou annuler son rendez-vous.',
            crmAppointmentConfirmation: 'Message de confirmation de rendez-vous du CRM',
            crmAppointmentConfirmationTooltip: 'Ce message est envoyé pour les confirmations de rendez-vous programmées à partir d\'une fiche client dans le CRM.',
            paymentMessage: 'Message d\'envoi de lien de paiement',
            paymentMessageTooltip: 'Ce message est ajouté automatiquement à la fin d\'un envoi de lien de paiement. Il est suivi du lien de paiement.',
            appendConfirmationMessage: 'Annexer le message de confirmation à ce message',
            insertAttribute: 'Insérer un attribut',
            unsubscribeMessageWarning: 'Nous recommandons d\'écrire un message puisque la loi exige un mécanisme de désinscription pour les communications marketing.',
            crmConfirmationWarning: 'Lorsque le message n\'est spécifié que dans une langue, il sera utilisé pour toutes langues.',
            crmConfirmationError: 'Le message de confirmation de rendez-vous du CRM est requis dans au moins une des langues.',
            subtitles: {
                messages: 'Messages automatisés',
            },
            messages: {
                updateSuccessful: 'Messages automatisés enregistrés avec succès.',
            },
            errors: {
                update: 'Une erreur est survenue lors de la sauvegarde.',
            },
        },
        teamDetails: {
            address: 'Adresse',
            city: 'Ville',
            province: 'Province',
            state: 'État',
            country: 'Pays',
            postalCode: 'Code postal',
            zip: 'Code ZIP',
            hasAppointments: 'Accès aux rendez-vous',
            doesNotHaveAppointments: 'Pas d\'accès aux rendez-vous',
            hasCampaigns: 'Accès aux campagnes',
            doesNotHaveCampaigns: 'Pas d\'accès aux campagnes',
            hasPayments: 'Accès aux paiements',
            doesNotHavePayments: 'Pas d\'accès aux paiements',
            phone: 'Téléphone',
            name: 'Nom',
            timezone: 'Fuseau horaire',
            appointmentAccess: 'Rendez-vous',
            campaignAccess: 'Campagnes',
            paymentAccess: 'Paiements',
            number: 'Numéro',
            noPhones: 'Aucun numéro de téléphone.',
            subtitles: {
                teamDetails: 'Détails de l\'organisation',
                phones: 'Numéros de téléphone',
                modules: 'Modules',
            },
            messages: {
                updateSuccessful: 'Informations de l\'organisation modifiées avec succès.',
            },
            errors: {
                fetchingPhones: 'Une erreur s\'est produite lors de la récupération des numéros de téléphone.',
                fetchingAccount: 'Une erreur s\'est produite lors de la récupération du compte.',
                update: 'Une erreur est survenue lors de la sauvegarde.',
            },
        },
        users: {
            leftNav: {
                profile: 'Profil',
                notifications: 'Alertes',
                messages: 'Messages automatisés',
                permissions: 'Permissions',
            },
            name: 'Nom',
            email: 'Courriel',
            active: 'Actif',
            noUsers: 'Aucun utilisateur.',
            userModal: {
                addTitle: 'Nouvel utilisateur',
                editTitle: 'Modification d\'utilisateur',
                password: 'Mot de passe',
                passwordConfirmation: 'Confirmation du mot de passe',
                locale: 'Langue',
                isActive: 'Le compte de l\'utilisateur est activé',
                isNotActive: 'Le compte de l\'utilisateur est désactivé',
                successMessage: 'L\'utilisateur a été créé avec succès.',
                updateMessage: 'L\'utilisateur a été modifié avec succès.',
                deleteMessage: 'L\'utilisateur a été supprimé avec succès.',
            },
            deleteModal: {
                header: 'Suppression d\'utilisateur',
                message: 'Voulez-vous vraiment supprimer l\'utilisateur sélectionné?',
            },
            subtitles: {
                users: 'Utilisateurs',
            },
            errors: {
                fetchingUsers: 'Impossible de récupérer les utilisateurs.',
            },
            permissions: {
                type: 'Permission',
                appointmentModule: 'Module Rendez-vous',
                campaignModule: 'Module Campagnes',
                paymentModule: 'Module Paiements',
                teamSettings: 'Paramètres de l\'organisation',
                otherUsersConversations: 'Conversations des autres utilisateurs (Lecture seule)',
                subtitles: {
                    permissions: 'Permissions',
                },
                allowed: 'Accès autorisé',
            },
        },
        templates: {
            title: 'Messages prédéfinis',
            categories: 'Catégories',
            templates: 'Messages',
        },
    },
};
